import staging from './staging';
import production from './production';
import env from './env';

const config = env === 'production' ? production : staging;

export default config;
